<script>
const data = [
  {
    Designation: "Web Designer",
    Department: "Designing",
    Image: "user-34.jpg",
    Approved_By: "Doglas Martini",
    Roll: "Manager",
    Created_Date: "14 Jan 2024",
    Status: "Active",
  },
  {
    Designation: "Web Developer",
    Department: "Developer",
    Image: "user-34.jpg",
    Approved_By: "Doglas Martini",
    Roll: "Manager",
    Created_Date: "21 Jan 2024",
    Status: "Active",
  },
  {
    Designation: "IOS Developer",
    Department: "Developer",
    Image: "user-34.jpg",
    Approved_By: "Doglas Martini",
    Roll: "Manager",
    Created_Date: "18 Feb 2024",
    Status: "Active",
  },
  {
    Designation: "Android Developer",
    Department: "Developer",
    Image: "user-34.jpg",
    Approved_By: "Doglas Martini",
    Roll: "Manager",
    Created_Date: "24 Feb 2024",
    Status: "Active",
  },
  {
    Designation: "DevOps Engineer",
    Department: "DevOps",
    Image: "user-34.jpg",
    Approved_By: "Doglas Martini",
    Roll: "Manager",
    Created_Date: "11 Mar 2024",
    Status: "Active",
  },
];

const columns = [
  {
    sorter: false,
  },
  {
    title: "Designation",
    dataIndex: "Designation",
    key: "Designation",
    sorter: {
      compare: (a, b) => {
        a = a.Designation.toLowerCase();
        b = b.Designation.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Department",
    dataIndex: "Department",
    sorter: {
      compare: (a, b) => {
        a = a.Department.toLowerCase();
        b = b.Department.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Approved By",
    dataIndex: "Approved_By",
    key: "Approved_By",
    sorter: {
      compare: (a, b) => {
        a = a.Approved_By.toLowerCase();
        b = b.Approved_By.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Created Date",
    dataIndex: "Created_Date",
    sorter: {
      compare: (a, b) => {
        a = a.Created_Date.toLowerCase();
        b = b.Created_Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

export default {
  data() {
    return {
      data,
      columns,
      rowSelection,
    };
  },
};
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="data"
    :row-selection="rowSelection"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Designation'">
        <div class="d-flex align-items-center file-name-icon">
          <div class="ms-2">
            <h6 class="fw-medium">
              <a href="javascript:void(0);">{{ record.Designation }}</a>
            </h6>
          </div>
        </div>
      </template>
      <template v-if="column.key === 'Approved_By'">
        <div class="d-flex align-items-center file-name-icon">
          <a href="javascript:void(0);" class="avatar avatar-md avatar-rounded">
            <img
              :src="require(`@/assets/img/users/${record.Image}`)"
              class="img-fluid"
              alt="img"
            />
          </a>
          <div class="ms-2">
            <h6 class="fw-medium">
              <a href="javascript:void(0);">{{ record.Approved_By }}</a>
            </h6>
            <p class="fs-12">{{ record.Roll }}</p>
          </div>
        </div>
      </template>
      <template v-if="column.key === 'Status'">
        <span class="badge badge-success d-inline-flex align-items-center badge-xs">
          <i class="ti ti-point-filled me-1"></i>{{ record.Status }}
        </span>
      </template>
      <template v-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            href="javascript:void(0);"
            class="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_performance-indicator"
            ><i class="ti ti-edit"></i
          ></a>
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            ><i class="ti ti-trash"></i
          ></a>
        </div>
      </template>
    </template>
  </a-table>
</template>
